import * as LoginService from "../../services/loginService";
import * as UserService from "../../services/user-service";
import { Constants } from "../../constants";
import {
  GET_USER_DATA_FAILED,
  GET_USER_DATA_IN_PROGRESS,
  GET_USER_DATA_SUCCESSFUL,
  LOGIN_FAILED,
  LOGIN_IN_PROGRESS,
  LOGIN_SUCCESSFUL,
  LOGOUT
} from "./action-types";

export function login(email, password) {
  return function(dispatch) {
    dispatch({ type: LOGIN_IN_PROGRESS, payload: {} });
    LoginService.login(email, password)
      .then(loginResponse => {
        const token = loginResponse.headers["authorization"];
        localStorage.setItem(Constants.STORAGE_JWT_TOKEN_KEY, token);
        UserService.getUserDetails()
          .then(userDataResponse => {
            let user = userDataResponse.data;
            dispatch({
              type: GET_USER_DATA_SUCCESSFUL,
              payload: userDataResponse.data
            });
            dispatch({ type: LOGIN_SUCCESSFUL, payload: user });
          })
          .catch(err => {
            dispatch({
              type: LOGIN_FAILED,
              payload: {
                errors: {
                  summary: "Incearca din nou!"
                },
                status: err.status
              }
            });
          });
      })
      .catch(err => {
        let status;
        try {
          status = err.response.data.status;
        } catch (err) {}
        dispatch({
          type: LOGIN_FAILED,
          payload: {
            errors: {
              summary:
                status === 401
                  ? "Emailul sau parola sunt gresite!"
                  : "A aparut o eroare. Va rog reincercati!"
            }
          }
        });
      });
  };
}

export function getUserData() {
  return function(dispatch) {
    dispatch({
      type: GET_USER_DATA_IN_PROGRESS,
      payload: {}
    });
    UserService.getUserDetails()
      .then(userDataResponse => {
        dispatch({
          type: GET_USER_DATA_SUCCESSFUL,
          payload: userDataResponse.data
        });
      })
      .catch(err => {
        dispatch({
          type: GET_USER_DATA_FAILED,
          payload: {
            errors: err
          }
        });
      });
  };
}

export function logout() {
  return function(dispatch) {
    dispatch({ type: LOGOUT, payload: {} });
  };
}
